import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { LinkPropTypes } from '@/constants/propTypes';
import { useAppSelector } from '@/redux';
import styles from './MenuLink.module.scss';

const DesktopMenuLink = dynamic(() => import('./DesktopMenuLink'));
DesktopMenuLink.displayName = 'DesktopMenuLink';
const MobileMenuLink = dynamic(() => import('./MobileMenuLink'));
MobileMenuLink.displayName = 'MobileMenuLink';

export const MenuLink = ({
	id,
	isMobile,
	link,
	type,
	className,
	handleMouseEnter,
	handleMouseLeave,
	handleClick,
	children,
	fontColor,
	isOpen,
	isActiveLink,
}) => {
	const isEc = useAppSelector(({ auth }) => !!auth.loggedUser?.isEc);
	const { showEc, className: linkClass, groupIdentifier } = link;
	const displayLink = showEc ? isEc : true;

	const linkId = useMemo(() => {
		const params = id
			? id
			: [type, groupIdentifier]
					.filter((item) => !!item)
					.map((item) => item.toLowerCase())
					.join('-');
		return `menu-link${params ? `-${params}` : ''}`;
	}, [id, type, groupIdentifier]);

	const linkClassName = [className, linkClass].filter((item) => !!item).join(' ') || '';

	return displayLink ? (
		<div className={styles['menu-link']} data-test-id="menu-link">
			{isMobile ? (
				<MobileMenuLink
					id={linkId}
					link={link}
					type={type}
					linkClassName={{ container: linkClassName }}
					handleClick={handleClick}
				/>
			) : (
				<DesktopMenuLink
					id={linkId}
					link={link}
					type={type}
					linkClassName={linkClassName}
					handleClick={handleClick}
					handleMouseEnter={handleMouseEnter}
					handleMouseLeave={handleMouseLeave}
					fontColor={fontColor}
					isOpen={isOpen}
					isActiveLink={isActiveLink}
				>
					{children}
				</DesktopMenuLink>
			)}
		</div>
	) : null;
};

MenuLink.propTypes = {
	id: PropTypes.string,
	isMobile: PropTypes.bool.isRequired,
	link: PropTypes.shape(LinkPropTypes).isRequired,
	type: PropTypes.string,
	className: PropTypes.string,
	handleMouseEnter: PropTypes.func,
	handleMouseLeave: PropTypes.func,
	handleClick: PropTypes.func,
	children: PropTypes.object,
	isEc: PropTypes.bool,
	fontColor: PropTypes.string,
	isOpen: PropTypes.bool,
	isActiveLink: PropTypes.bool,
};

export default MenuLink;
